import { omit } from 'ramda';

const walls = wallType  => {
  if (wallType) return { url : `//www.tourconnect.com/${wallType}` };
  return { url: '//www.tourconnect.com/upgrade-gen-send-assets/' };
};

const initialState = {
  open: false,
  ...walls(),
  blocker: false,
  skipBack: false,
};

export default function wallReducer(state = initialState, action) {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE': // URL matches
      const { payload: { pathname } } = action;
      if (pathname.match(/contracting\/master-template-list/)) {
        return {
          ...state,
          ...walls('upgrade-rates-corp'),
          blocker: true,
          skipBack: false,
          open: true,
        };
      }
      if (pathname.match(/contracting\/create-master-template/)) return {
        ...state,
        ...walls('upgrade-rates-corp'),
        blocker: true,
        skipBack: false,
        open: true,
      };
      if (pathname.match(/contracting\/reports\/diff\/template/)) return {
        ...state,
        ...walls('upgrade-rates-temp-compare'),
        blocker: true,
        skipBack: false,
        open: true,
      }
      if (pathname.match(/contracting\/reports\/diff\/contract/)) return {
        ...state,
        ...walls('upgrade-rates-ctrct-compare'),
        blocker: true,
        skipBack: false,
        open: true,
      }
      if (pathname.match(/contracting\/supplier-dashboard/)) return {
        ...state,
        ...walls('upgrade-rates-sup-dash'),
        open: true,
        skipBack: false,
        blocker: true,
      }
      if (pathname.match(/contracting\/buyer-dashboard/)) return {
        ...state,
        ...walls('upgrade-rates-buy-dash'),
        open: true,
        skipBack: false,
        blocker: true,
      }
      if (pathname.match(/workspace\/bulkmessages/)) return {
        ...state,
        ...walls('upgrade-pm-bulk-msg'),
        open: true,
        blocker: false,
      }
      if (pathname.match(/contracting\/contract\/(.+)\/notes/)) return {
        ...state,
        ...walls('upgrade-rates-workflow'),
        open: true,
        blocker: false,
      }
      return state;
    case '[wall] openClose': // reducer action maches
      const { payload: open } = action;
      return {
          ...state,
        ...walls(),
        open,
        blocker: open ? state.blocker : false,
      };
    case '[wall] openSlug':
      const { payload, payload: { slug } } = action;
      return {
          ...state,
        ...walls(slug),
        ...omit(['slug'], payload),
        open: true,
      };
    case '[contract-list]GET_CONTRACT_FORWARDING_EMAIL':
      return {
        ...state,
        ...walls('upgrade-page-contracting-workflow-fwd'),
        open: true,
        blocker: false,
      };
    case 'UPDATE_PROPS_IN_CONTRACT_LISTING':
      const { payload: { folderAction, createNewFolder } } = action;
      if (folderAction === 'assign' || createNewFolder === true) {
        return {
          ...state,
          ...walls('upgrade-rates-workflow'),
          open: true,
          blocker: false,
        };
      }
      return state;
    case '{contracting} ADD_DRAFT_TO_QUEUE':
      return {
        ...state,
        ...walls('upgrade-rates-updates'),
        open: true,
        blocker: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/wall/__store__/reducer.js